/**
 * @fileoverview FavoritesEmptyState — NonIdealState used in the Favorites
 * section of the Control Panel home when the user has not starred any
 * settings yet. Muted star-empty icon + description + primary CTA.
 *
 * Foundry mapping: `bp6-non-ideal-state bp6-non-ideal-state-vertical
 * control-panel-app__favorites-container__1py9ndi`.
 */

import { NonIdealState, type IconName } from "@blueprintjs/core";
import type { ReactElement, ReactNode } from "react";

interface FavoritesEmptyStateProps {
  description?: ReactNode;
  /** Action element (typically a Button); rendered below the description. */
  action?: ReactNode;
  icon?: IconName;
  className?: string;
}

export function FavoritesEmptyState({
  description = "Favorite your frequently visited settings for easy access",
  action,
  icon = "star-empty",
  className,
}: FavoritesEmptyStateProps): ReactElement {
  return (
    <NonIdealState data-testid="favorites-empty-state"
      className={["bp-favorites-empty-state", className].filter(Boolean).join(" ")}
      icon={icon}
      iconSize={32}
      iconMuted
      description={<div className="bp6-text-muted">{description}</div>}
      action={action as ReactElement | undefined}
      layout="vertical"
    />
  );
}
